export const environment = {
  production: false,
  apiUrl: 'https://api.esketit-test.dx-compliance.com/v1',
  customer: 'esketit',
  branch: 'dev'
};
